export default __webpack_public_path__ + "static/media/cod.fbde35ee.svg";